import { ClaimGenerateUuidUsecase } from '../../../application';

export default class ClaimGenerateUuidServices {
    constructor() {}

    async execute(event) {
        const request = await ClaimGenerateUuidUsecase(event);

        return request;
    }
}
